export function getPracticeHTMLStatus(status) {
    const span = (text, color) => {
        return `<span class="status status_${color}">${text}</span>`
    }

    switch (status) {
        case 1: {
            return span(this.t("course.passed"), "green")
        }
        case 2: {
            return span(this.t("course.failed"), "red")
        }
        case 3: {
            return span(this.t("course.need_rework"), "yellow")
        }
        case 4: {
            return span(this.t("attempt.statuses.4"), "yellow")
        }
        case 5: {
            return span(this.t("course.in_process"), "gray")
        }
        case 6: {
            return span(this.t("create-course.on_checking"), "yellow")
        }
    }
    return ""
}
